import { createClient, postParseCSV, postCreateGroup, fetchGroups, postUpdateGroup, sendDeleteGroup } from '../api'

// ---- Bulk ----
export const parseCSV = async({ commit, dispatch }, data) => {
  try {
    const res = await postParseCSV(data)
    if (res && res instanceof Error) throw res
    commit('USERS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const createBulkUsers = async({ commit, dispatch, getters }, data) => {
  try {
    const res = await createClient({ currentUser: { _id: getters.getMyInfo._id }, newUsers: data, group: getters.activeGroup })
    if (res && res instanceof Error) throw res
    commit('TOAST_USER', 'Bulk users added!')
    await dispatch('getGroups', {})
    return res
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

// ---- Groups ----
export const createGroup = async ({ commit, dispatch, getters }, data) => {
  try {
    data.owner = getters.getMyInfo._id
    const res = await postCreateGroup(data)
    if (res && res instanceof Error) throw res
    commit('TOAST_GROUP', `${data.name} was created!`)
    commit('SET_ACTIVE_GROUP', res.data._id)
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const getGroups = async ({ commit, dispatch, getters }, { page, pageSize }) => {
  try {
    const res = await fetchGroups(getters.getMyInfo._id, page, pageSize)
    if (res && res instanceof Error) throw res
    commit('SET_GROUPS', { data: res.data.results, total: res.data.total, page: res.data.page, pageSize: res.data.pageSize })
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const updateGroup = async ({ commit, dispatch, getters }, data) => {
  try {
    const group = getters.group
    const res = await postUpdateGroup(group._id, data)
    if (res && res instanceof Error) throw res
    commit('TOAST_GROUP', `${data.name} was updated!`)
    commit('SET_ACTIVE_GROUP')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const deleteGroup = async ({ commit, dispatch, getters }) => {
  try {
    const group = getters.group
    const res = await sendDeleteGroup(group._id)
    if (res && res instanceof Error) throw res
    commit('TOAST_GROUP', `${group.name} was deleted!`)
    commit('SET_ACTIVE_GROUP')
  } catch (err) {
    commit('TOAST_ERROR', err.toast)
    return false
  }
}

export const setActiveGroup = ({ commit }, data) => {
  commit('SET_ACTIVE_GROUP', data)
}

export const resetActiveGroup = ({ commit }) => {
  commit('SET_ACTIVE_GROUP')
}



// WEBPACK FOOTER //
// ./src/app/store/groups/actions.js